import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

const AddEdit_UserMaster = () => {
  const API_URL_SAVE = "UserMaster/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/UserMaster/Id";
  const API_URL_USERTYPE = `${API_WEB_URLS.MASTER}/0/token/UserTypeMaster/Id/0`;

  const [state, setState] = useState({ id: 0, formData: { FullName: "", UserName: "", UserPass: "", F_UserType: "", Email: "" } });
  const [userTypeList, setUserTypeList] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const usernameRef = useRef(null);

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    Fn_FillListData(dispatch, setUserTypeList, "gridData", API_URL_USERTYPE);
  }, [dispatch]);

  useEffect(() => { if (usernameRef.current) usernameRef.current.focus(); }, []);

  const validationSchema = Yup.object({
    FullName: Yup.string().required("Required").min(2).max(100),
    UserName: Yup.string().required("Required").min(3).max(100),
    UserPass: state.id === 0 ? Yup.string().required("Required").min(6).max(100) : Yup.string().min(6).max(100),
    F_UserType: Yup.string().required("Required"),
    Email: Yup.string().required("Required").email("Invalid").max(100),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    let formData = new FormData();
    formData.append("FullName", values.FullName || "");
    formData.append("UserName", values.UserName || "");
    formData.append("UserPass", values.UserPass || "");
    formData.append("F_UserType", values.F_UserType || "");
    formData.append("Email", values.Email || "");
    formData.append("UserId", obj == null || obj === undefined ? 0 : obj.uid);
    Fn_AddEditData(dispatch, setState, { arguList: { id: state.id, formData } }, API_URL_SAVE, true, "userid", navigate, "/UserMaster");
  };

  return (
    <div style={{ padding: "6px 8px", maxWidth: 900, margin: "0 auto" }}>
      <Card className="border shadow-none" style={{ marginBottom: 0 }}>
        <CardBody className="p-2" style={{ padding: "8px 12px !important" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>User Master</span>
            <div style={{ display: "flex", gap: 6 }}>
              <Button type="button" size="sm" color="light" className="py-1 px-2" style={{ fontSize: 12 }} onClick={() => navigate("/UserMaster")}><ArrowLeft size={12} className="me-1" />Back</Button>
              <Button type="submit" form="user-form" size="sm" color="primary" className="py-1 px-2" style={{ fontSize: 12 }}><Save size={12} className="me-1" />Save</Button>
            </div>
          </div>
          <Formik
            initialValues={{
              FullName: state.formData.FullName || "",
              UserName: state.formData.UserName || "",
              UserPass: "",
              F_UserType: state.formData.F_UserType !== undefined && state.formData.F_UserType !== null ? String(state.formData.F_UserType) : "",
              Email: state.formData.Email || "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, touched }) => (
              <Form id="user-form" style={{ marginTop: 4 }}>
                <Row style={{ gap: "0 8px", rowGap: 2 }}>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Full Name <span className="text-danger">*</span></label>
                    <Field innerRef={usernameRef} className={`form-control form-control-sm ${errors.FullName && touched.FullName ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="text" name="FullName" placeholder="Full name" />
                    <ErrorMessage name="FullName" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Username <span className="text-danger">*</span></label>
                    <Field className={`form-control form-control-sm ${errors.UserName && touched.UserName ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="text" name="UserName" placeholder="Username" />
                    <ErrorMessage name="UserName" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Password {state.id === 0 && <span className="text-danger">*</span>}</label>
                    <Field className={`form-control form-control-sm ${errors.UserPass && touched.UserPass ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="password" name="UserPass" placeholder={state.id === 0 ? "Password" : "Leave blank to keep"} />
                    <ErrorMessage name="UserPass" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>User Type <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.F_UserType && touched.F_UserType ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_UserType">
                      <option value="">Select</option>
                      {userTypeList && userTypeList.map((ut) => <option key={ut.Id} value={ut.Id}>{ut.Name}</option>)}
                    </Field>
                    <ErrorMessage name="F_UserType" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Email <span className="text-danger">*</span></label>
                    <Field className={`form-control form-control-sm ${errors.Email && touched.Email ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="email" name="Email" placeholder="Email" />
                    <ErrorMessage name="Email" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddEdit_UserMaster;
